<template lang="pug">
  app-modal.modalRetificao(
    titulo="Solicitar Retificação",
    :width="width"
    @closeModal="closeModal"
  )
    template(slot="body")
      h4 Assunto: Solicitar Retificação - Processo n° {{numeroProcesso}}
      app-label(
        label="Especifique os campos a serem retificados no cadastro:",
        :required="true"
      )
      validation-observer(ref='validation' tag='form')
        validation-provider(rules="required", v-slot="{ errors }")
          app-editor-texto.input(
            :value="conversa",
            @onTextChange="setConversa"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
        h4 Anexos mensagem
          app-anexo(
            :id="'upload-notificacao'"
            @removeFile="removeFile",
            @uploadFile="uploadFile",
            :exibirDownload="false",
            :files="anexos",
            scope="anexos",
            v-model="anexos",
          )
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="closeModal"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small"
          @click="enviar"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>
<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'
import AppAnexo from '@/components/AppAnexo'
import AppLabel from '@/components/AppLabel'
import FileHelper from '@/utils/fileHelper'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import messages from '@/constants/messages'
const { tiposProcessoFisico } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppAnexo,
    AppLabel,
    AppEditorTexto,
    FileHelper
  },

  data () {
    return {
      conversa: '',
      anexos: [],
      tiposProcessoFisico
    }
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    },
    numeroProcesso: {
      required: false
    },
    tipoProcesso: {
      required: false
    },
    setor: {
      required: false
    },
    width: {
      required: false
    },
    refresh: {
      type: Boolean
    }
  },

  created () {
    //
  },

  methods: {
    ...mapActions({
      retificar: 'processo/retificarProcesso',
      downloadDocumentos: 'download/download'
    }),
    setConversa (value) {
      this.conversa = value
    },
    async uploadFile (file) {
      this.anexos.push({ key: file.response, nome: file.name })
    },
    async download (anexo) {
      const arquivo = await this.downloadDocumentos(anexo)

      FileHelper.saveFile(arquivo, anexo.nome)
    },
    removeFile (file) {
      const teste = this.anexos.findIndex(obj => obj === file)
      this.anexos.splice(teste, 1)
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    closeModal () {
      this.$confirm(
        'Ao fechar a tela, os dados preenchidos serão perdidos e a retificação não será solicitada. Tem certeza que seja confirmar esta ação?',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          this.$emit('closeModal')
        })
        .catch(() => {
        })
    },
    alertaModalRetificacao () {
      if (this.tipoProcesso && this.tiposProcessoFisico.includes(this.tipoProcesso)) {
        return messages.TEXTO_RETIFICACAO_PROCESSO_FISICO
      }
      return messages.TEXTO_RETIFICACAO_PROCESSO_REURB_INDIVIDUAL
    },
    voltarListagem () {
      this.$router.push({
        name: 'CAIXA_EMISSAO_TITULO'
      })
    },
    async enviar () {
      if (!await this.checkValidacao()) {
        return
      }
      const conversa = {
        conversa: {
          assunto: 'Solicitar Retificação',
          processo: {
            id: this.idProcesso
          },
          mensagemList: [
            {
              conteudo: this.conversa,
              anexoList: this.anexos
            }
          ]
        },
        setor: this.setor,
        tipoConversaEnum: 'SOLICITACAO_RETIFICACAO'
      }
      this.$confirm(
        this.alertaModalRetificacao(),
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then((action) => {
          this.retificar(conversa).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Uma retificação foi solicitada.')
          }).catch(() => {
          }).finally(() => {
            if (this.refresh) {
              this.$emit('refresh')
            } else {
              if (this.$router.history?.current?.name === 'continuar-emissao-titulo') {
                this.voltarListagem()
              } else {
                this.$router.back()
              }
            }
            this.$emit('closeModal')
          })
        }).catch(() => {
        })
    }
  }
}
</script>
<style>

.divider {
  border-bottom: solid 2px #dfe4ed;
  width: 100%;
}

.margin40 {
  margin-top: 40px;
}

.padding {
  padding-top: 10px;
}

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

@media (max-width: 780px) {
  .modalRetificao {
    width: 395px !important;
  }

  .el-message-box {
    position: absolute;
    left: 0px;
    width: 360px;
    top: 30%;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalSolicitarRetificacao.vue